module.exports = __webpack_public_path__ + "media/images/trailer-b8b0823dd12f638942701ae7e6282810.svg";